<ion-app>
	<ion-split-pane content-id="main">


		<ion-menu id="app-menu" contentId="main" *ngIf="isLoggedIn && isAuthenticated && user_id">

			<ion-header>
				<ion-toolbar>

					<ion-menu-toggle slot="start" mode="ios">
						<ion-button fill="none" close>
							<fa-icon [icon]="['fal','chevron-left']" slot="start"></fa-icon>
						</ion-button>
					</ion-menu-toggle>

					<ion-title>Menu</ion-title>
				</ion-toolbar>
			</ion-header>

			<ion-content [scrollEvents]="true">
				<ion-list class="menu-list">
					<ion-menu-toggle auto-hide="false">
						<ion-item routerDirection="root" routerLink="app/tabs/home/" lines="none" detail="false" routerLinkActive="selected">
							<fa-icon [icon]="['fal','house']" slot="start"></fa-icon>
							<ion-label>{{uiState?.readySteady}}</ion-label>
						</ion-item>
					</ion-menu-toggle>


					<ion-accordion-group id="my_menu">
						<ion-accordion value="my_menu">
							<ion-item slot="header" auto-hide="true" (click)="scrollToTop('my_menu')">

								<ion-label>My Menu</ion-label>
							</ion-item>

							<ion-list slot="content">
								<ion-menu-toggle auto-hide="false">


									<ion-menu-toggle auto-hide="false">

										<ion-item routerDirection="root" routerLink="app/tabs/activesafe" lines="none" detail="false" routerLinkActive="selected">
											<ion-img src="assets/svgs/ActiveSafe.svg" slot="start" class="activesafe-icon"></ion-img>
											<ion-label>ActiveSafe<!--<br/>Active Safe Hubs--></ion-label>
										</ion-item>




										<ion-item routerDirection="root" routerLink="app/tabs/switch-clubs/" lines="none" detail="false" routerLinkActive="selected">
											<fa-icon [icon]="['fal', 'arrow-up-arrow-down']" slot="start" rotate="90"></fa-icon>
											<ion-label>My Clubs</ion-label>
										</ion-item>

										<ion-item routerDirection="root" routerLink="app/tabs/my-details/" lines="none" detail="false" routerLinkActive="selected">
											<fa-icon [icon]="['fal', 'circle-user']" slot="start"></fa-icon>
											<ion-label>
												My Details
											</ion-label>
										</ion-item>

										
										<ion-item routerDirection="root" routerLink="app/tabs/user-year/" lines="none" detail="false" routerLinkActive="selected">
											<fa-icon [icon]="['fal', 'calendar-clock']" slot="start"></fa-icon>
											<ion-label>My
												{{thisYear}}</ion-label>
										</ion-item>

										<ion-item routerDirection="root" routerLink="app/tabs/user-settings-connected-apps" lines="none" detail="false" routerLinkActive="selected">
											<fa-icon [icon]="['fal', 'link-simple']" slot="start"></fa-icon>
											<ion-label>Apps</ion-label>
										</ion-item>

										<ion-item routerDirection="root" routerLink="app/tabs/user-settings-comms" lines="none" detail="false" routerLinkActive="selected" *ngIf="sideBarMenu?.includes('no_club') == false">
											<fa-icon [icon]="['fal', 'tower-cell']" slot="start"></fa-icon>
											<ion-label>Comms/GDPR</ion-label>
										</ion-item>

										
										@if(isNative) {
										<ion-item routerDirection="root" routerLink="app/tabs/user-settings-connected-devices" lines="none" detail="false" routerLinkActive="selected">
											<fa-icon [icon]="['fal', 'watch']" slot="start"></fa-icon>
											<ion-label>Devices</ion-label>
										</ion-item>
										}


										<ion-item routerDirection="root" routerLink="app/tabs/user-events/" lines="none" detail="false" routerLinkActive="selected">
											<div class="cmc-icon svg-inline--fa cmc-icon-menu"></div>
											<ion-label>
												Events
											</ion-label>
										</ion-item>

										<ion-item routerDirection="root" routerLink="app/tabs/pace-calculator/" lines="none" detail="false" routerLinkActive="selected">
											<fa-icon [icon]="['fal', 'stopwatch']" slot="start"></fa-icon>
											<ion-label>
												Pace Calculator
											</ion-label>
										</ion-item>

										<ion-item routerDirection="root" routerLink="app/tabs/parkrun/" lines="none" detail="false" routerLinkActive="selected">
											<fa-icon [icon]="['fal', 'barcode']" slot="start"></fa-icon>
											<ion-label>
												parkrun
											</ion-label>
										</ion-item>

										<ion-item routerDirection="root" routerLink="app/tabs/user-settings-switch" lines="none" detail="false" routerLinkActive="selected" *ngIf="sideBarMenu?.includes('no_club') == false">
											<fa-icon [icon]="['fal', 'repeat']" slot="start"></fa-icon>
											<ion-label>Switch User</ion-label>
										</ion-item>

										@if(!uiState.showingMembershipForm){
										<ion-item routerDirection="root" routerLink="app/tabs/training-sessions/" lines="none" detail="false" routerLinkActive="selected">
											<fa-icon [icon]="['fal', 'watch-fitness']" slot="start"></fa-icon>
											<ion-label>Training Sessions</ion-label>
										</ion-item>

										<ion-item routerDirection="root" routerLink="app/tabs/training-history/" lines="none" detail="false" routerLinkActive="selected" *ngIf="sideBarMenu?.includes('no_club') == false">
											<fa-icon [icon]="['fal', 'rectangle-history']" slot="start"></fa-icon>
											<ion-label>Training History
											</ion-label>
										</ion-item>
										}


									</ion-menu-toggle>


								</ion-menu-toggle>
							</ion-list>
						</ion-accordion>
					</ion-accordion-group>

					@if(!uiState.showingMembershipForm){
					<div *ngIf="sideBarMenu?.includes('supplier') == false">

						<div id="menu_training" *ngIf="sideBarMenu?.includes('training_section') == false">

							<ion-list-header mode="ios">
								Training
							</ion-list-header>

							<ion-menu-toggle auto-hide="false">
								<ion-item routerDirection="root" routerLink="app/tabs/training-sessions/" lines="none" detail="false" routerLinkActive="selected">
									<fa-icon [icon]="['fal', 'watch-fitness']" slot="start"></fa-icon>
									<ion-label>
										Sessions
									</ion-label>
								</ion-item>

								<ion-item routerDirection="root" routerLink="app/tabs/training-leaders/" lines="none" detail="false" routerLinkActive="selected" *ngIf="clubSubscribed">
									<fa-icon [icon]="['fal', 'person-chalkboard']" slot="start"></fa-icon>
									<ion-label>
										Leaders
									</ion-label>
								</ion-item>

								<ion-item routerDirection="root" routerLink="app/tabs/training-plans/" lines="none" detail="false" routerLinkActive="selected" *ngIf="sideBarMenu?.includes('training_plans') == false">
									<fa-icon [icon]="['fal', 'list-check']" slot="start"></fa-icon>
									<ion-label>
										Plans
									</ion-label>
								</ion-item>
								<ion-item routerDirection="root" routerLink="app/tabs/training-routes/" lines="none" detail="false" routerLinkActive="selected" *ngIf="sideBarMenu?.includes('training_routes') == false">
									<fa-icon [icon]="['fal', 'route']" slot="start"></fa-icon>
									<ion-label>
										Routes
									</ion-label>
								</ion-item>


								<ion-item routerDirection="root" routerLink="app/tabs/training-settings/" lines="none" detail="false" routerLinkActive="selected">
									<fa-icon [icon]="['fal', 'gears']" slot="start"></fa-icon>
									<ion-label>
										Settings
									</ion-label>
								</ion-item>
								<ion-item routerDirection="root" routerLink="app/tabs/training-wallet/" lines="none" detail="false" routerLinkActive="selected" *ngIf="sideBarMenu?.includes('training_wallet') == false">
									<fa-icon [icon]="['fal', 'wallet']" slot="start"></fa-icon>
									<ion-label>
										Wallet
									</ion-label>
								</ion-item>
							</ion-menu-toggle>
						</div>


						<div *ngIf="sideBarMenu?.includes('messaging_section') == false">
							<ion-list-header mode="ios">
								Messaging
							</ion-list-header>
							<ion-menu-toggle auto-hide="false">

								<ion-item routerDirection="root" routerLink="app/tabs/direct-messages/no" lines="none" detail="false" routerLinkActive="selected" *ngIf="sideBarMenu?.includes('dms') == false">
									<fa-icon [hidden]="newDM" [icon]="['fal', 'message-arrow-up-right']" slot="start"></fa-icon>

									<ion-label>
										Direct Messages
									</ion-label>
								</ion-item>

								<ion-item routerDirection="root" routerLink="app/tabs/club-email/" lines="none" detail="false" routerLinkActive="selected" *ngIf="sideBarMenu?.includes('email_the_club') == false">
									<fa-icon [icon]="['fal', 'envelope']" slot="start"></fa-icon>
									<ion-label>
										Email The Club
									</ion-label>
								</ion-item>

								<ion-item routerDirection="root" routerLink="app/tabs/group-chats/" lines="none" detail="false" routerLinkActive="selected" *ngIf="sideBarMenu?.includes('group_messaging') == false">
									<fa-icon [hidden]="newGroupMsg" [icon]="['fal', 'people-line']" slot="start"></fa-icon>

									<ion-label>
										Group Chats</ion-label>
								</ion-item>

								<ion-item routerDirection="root" routerLink="app/tabs/message-board/no" lines="none" detail="false" routerLinkActive="selected" *ngIf="sideBarMenu?.includes('message_board') == false">
									<fa-icon [hidden]="newMessageBoard" [icon]="['fal', 'comments']" slot="start"></fa-icon>

									<ion-label>
										Message Board
									</ion-label>
								</ion-item>

							</ion-menu-toggle>
						</div>


						<ion-list-header mode="ios" *ngIf="sideBarMenu?.includes('no_club') == false">
							Club
						</ion-list-header>

						<ion-menu-toggle auto-hide="false">


							<div *ngIf="sideBarMenu?.includes('club_section') == false">


								<ion-item routerDirection="root" routerLink="app/tabs/club-announcements/no" lines="none" detail="false" routerLinkActive="selected" *ngIf="sideBarMenu?.includes('club_announcements') == false">
									<fa-icon [hidden]="newAnnouncement" [icon]="['fal', 'bullhorn']" slot="start"></fa-icon>

									<ion-label>
										Announcements
									</ion-label>
								</ion-item>

								@if(appState.hasAssociations){
								<ion-item routerDirection="root" routerLink="app/tabs/club-associations" lines="none" detail="false" routerLinkActive="selected">
									<fa-icon [icon]="['fal', 'chart-network']" slot="start"></fa-icon>
									<ion-label>Associations</ion-label>
								</ion-item>
								}

								<ion-item routerDirection="root" routerLink="app/tabs/club-calendar/all" lines="none" detail="false" routerLinkActive="selected" *ngIf="sideBarMenu?.includes('club_calendars') == false">
									<fa-icon [icon]="['fal', 'calendar']" slot="start"></fa-icon>
									<ion-label>
										Calendars
									</ion-label>
								</ion-item>


								<ion-item routerDirection="root" [routerLink]="['/app/tabs/training-map']" [queryParams]="{ page: 'club-activities' }" lines="none" detail="false" *ngIf="sideBarMenu?.includes('club_activities') == false">
									<fa-icon [icon]="['fal', 'globe-stand']" slot="start"></fa-icon>
									<ion-label>
										Clubmates' Activities
									</ion-label>
								</ion-item>


								<ion-item routerDirection="root" routerLink="app/tabs/club-records/" lines="none" detail="false" routerLinkActive="selected" *ngIf="sideBarMenu?.includes('club_records') == false">
									<fa-icon [icon]="['fal', 'award']" slot="start"></fa-icon>
									<ion-label>
										Club Records
									</ion-label>
								</ion-item>

								<ion-item routerDirection="root" routerLink="app/tabs/code-of-conduct" lines="none" detail="false" routerLinkActive="selected" *ngIf="sideBarMenu?.includes('code_of_conduct') == false">
									<fa-icon [icon]="['fal', 'handshake']" slot="start"></fa-icon>
									<ion-label>
										Code of Conduct
									</ion-label>
								</ion-item>
								<ion-item routerDirection="root" routerLink="app/tabs/club-competitions/" lines="none" detail="false" routerLinkActive="selected" *ngIf="sideBarMenu?.includes('club_competitions') == false">
									<fa-icon [icon]="['fal', 'trophy']" slot="start"></fa-icon>
									<ion-label>
										Competitions
									</ion-label>
								</ion-item>
								<ion-item routerDirection="root" routerLink="app/tabs/club-disclaimers" lines="none" detail="false" routerLinkActive="selected" *ngIf="sideBarMenu?.includes('club_disclaimers') == false">
									<fa-icon [icon]="['fal', 'file-contract']" slot="start"></fa-icon>
									<ion-label>
										Disclaimers
									</ion-label>
								</ion-item>
								<ion-item routerDirection="root" routerLink="app/tabs/club-documents" lines="none" detail="false" routerLinkActive="selected" *ngIf="sideBarMenu?.includes('club_documents') == false">
									<fa-icon [icon]="['fal', 'folder-tree']" slot="start"></fa-icon>
									<ion-label>
										Documents
									</ion-label>
								</ion-item>
								<ion-item routerDirection="root" routerLink="app/tabs/event-reports/" lines="none" detail="false" routerLinkActive="selected" *ngIf="sideBarMenu?.includes('event_reports') == false">
									<fa-icon [icon]="['fal', 'book-open']" slot="start"></fa-icon>
									<ion-label>
										Event Reports
									</ion-label>
								</ion-item>


								<ion-item routerDirection="root" routerLink="app/tabs/event-timer" lines="none" detail="false" routerLinkActive="selected" *ngIf="sideBarMenu?.includes('event_timer') == false && isNative">
									<div class="layered-icons">

										<fa-icon *ngIf="appState.canTimeEvents" [icon]="['fal', 'stopwatch']" slot="start"></fa-icon>
										<fa-icon *ngIf="canScanEvents" [icon]="['fal', 'qrcode']" slot="start"></fa-icon>
									</div>

									<ion-label>Event
									 @if(appState.canTimeEvents){ Timer/}Scanner
									</ion-label>
								</ion-item>


								<ion-item routerDirection="root" routerLink="app/tabs/club-info" lines="none" detail="false" routerLinkActive="selected" *ngIf="sideBarMenu?.includes('club_information') == false">
									<fa-icon [icon]="['fal', 'circle-info']" slot="start"></fa-icon>
									<ion-label>
										Information
									</ion-label>
								</ion-item>

								<ion-item routerDirection="root" routerLink="app/tabs/members-list/clubmates" lines="none" detail="false" routerLinkActive="selected" *ngIf="sideBarMenu?.includes('club_mates') == false">
									<fa-icon [icon]="['fal', 'users']" slot="start"></fa-icon>
									<ion-label>My Clubmates</ion-label>
								</ion-item>

								<ion-item routerDirection="root" routerLink="app/tabs/members-list/committee" lines="none" detail="false" routerLinkActive="selected" *ngIf="sideBarMenu?.includes('meet_committee') == false">
									<fa-icon [icon]="['fal', 'people-roof']" slot="start"></fa-icon>
									<ion-label>
										Meet the Committee
									</ion-label>
								</ion-item>
								<ion-item routerDirection="root" routerLink="app/tabs/members-list/welfare" lines="none" detail="false" routerLinkActive="selected" *ngIf="sideBarMenu?.includes('meet_committee/welfare') == false">
									<fa-icon [icon]="['fal', 'hand-heart']" slot="start"></fa-icon>
									<ion-label>
										Meet the Welfare Team
									</ion-label>
								</ion-item>
								<ion-item routerDirection="root" routerLink="app/tabs/members-list/leaders" lines="none" detail="false" routerLinkActive="selected" *ngIf="sideBarMenu?.includes('meet_committee/trraining') == false">
									<fa-icon [icon]="['fal', 'watch-fitness']" slot="start"></fa-icon>
									<ion-label>
										Meet the Training Team
									</ion-label>
								</ion-item>
							</div>

							<div *ngIf="sideBarMenu?.includes('no_club') == false">
								<ion-item routerDirection="root" routerLink="app/tabs/membership/" lines="none" detail="false" routerLinkActive="selected" *ngIf="sideBarMenu?.includes('membership') == false">
									<fa-icon [icon]="['fal', 'id-card']" slot="start"></fa-icon>
									<ion-label>
										Membership
									</ion-label>
								</ion-item>
							</div>


							<div *ngIf="sideBarMenu?.includes('club_section') == false">

								<ion-item routerDirection="root" routerLink="app/tabs/club-news/" lines="none" detail="false" routerLinkActive="selected" *ngIf="sideBarMenu?.includes('club_news') == false">
									<fa-icon [icon]="['fal', 'newspaper']" slot="start"></fa-icon>
									<ion-label>
										News
									</ion-label>
								</ion-item>

								<ion-item routerDirection="root" routerLink="app/tabs/discounts" lines="none" detail="false" routerLinkActive="selected" *ngIf="sideBarMenu?.includes('club_offers') == false">
									<ion-badge [hidden]="!newOffer" slot="start">New</ion-badge>
									<fa-icon [hidden]="newOffer" [icon]="['fal', 'badge-percent']" slot="start"></fa-icon>
									<ion-label>
										Offers &amp; Discounts
									</ion-label>
								</ion-item>
								<ion-item routerDirection="root" routerLink="app/tabs/photo-albums/" lines="none" detail="false" routerLinkActive="selected" *ngIf="sideBarMenu?.includes('photo_albums') == false">
									<fa-icon [icon]="['fal', 'images']" slot="start"></fa-icon>
									<ion-label>
										Photo Albums
									</ion-label>
								</ion-item>
								<ion-item routerDirection="root" routerLink="app/tabs/race-league" lines="none" detail="false" routerLinkActive="selected" *ngIf="sideBarMenu?.includes('race_league') == false">
									<fa-icon [icon]="['fal', 'flag-checkered']" slot="start"></fa-icon>
									<ion-label>
										Race League
									</ion-label>
								</ion-item>
								<ion-item routerDirection="root" routerLink="app/tabs/club-review" lines="none" detail="false" routerLinkActive="selected" *ngIf="sideBarMenu?.includes('reviews') == false">
									<fa-icon [icon]="['fal', 'star-sharp-half']" slot="start"></fa-icon>
									<ion-label>
										Review
									</ion-label>
								</ion-item>
								<ion-item routerDirection="root" routerLink="app/tabs/club-social" lines="none" detail="false" routerLinkActive="selected" *ngIf="sideBarMenu?.includes('social_media') == false">
									<fa-icon [icon]="['fal', 'signal-stream']" slot="start"></fa-icon>
									<ion-label>
										Social Media
									</ion-label>
								</ion-item>
								<ion-item routerDirection="root" routerLink="app/tabs/club-surveys/" lines="none" detail="false" routerLinkActive="selected" *ngIf="sideBarMenu?.includes('club_surveys') == false">
									<fa-icon [icon]="['fal', 'square-poll-horizontal']" slot="start"></fa-icon>
									<ion-label>
										Surveys
									</ion-label>
								</ion-item>
							</div>


							@if(appState.isAdmin){
							<ion-item routerDirection="root" routerLink="app/tabs/club-forum/0" lines="none" detail="false" routerLinkActive="selected">
								<fa-icon [icon]="['fal', 'screen-users']" slot="start"></fa-icon>
								<ion-label>connectMyClub Forum</ion-label>
							</ion-item>
							<ion-item routerDirection="root" routerLink="app/tabs/twofa" lines="none" detail="false" routerLinkActive="selected">
								<fa-icon [icon]="['fal', 'lock']" slot="start"></fa-icon>
								<ion-label>Two-Factor Authentication</ion-label>
							</ion-item>
							<ion-item button lines="none" detail="false" (click)="openClubPortal()">
								<ion-img src="assets/svgs/cMCCOrange.svg" class="app-icon"></ion-img>
								<ion-label>Club Portal</ion-label>
							</ion-item>
							}
						</ion-menu-toggle>


						<div *ngIf="sideBarMenu?.includes('shop_section') == false">
							<ion-list-header mode="ios">
								Club Shop
							</ion-list-header>
							<ion-menu-toggle auto-hide="false">

								<ion-item routerDirection="root" routerLink="app/tabs/club-shop/all_items" lines="none" detail="false" routerLinkActive="selected" *ngIf="sideBarMenu?.includes('club_shop') == false">
									<fa-icon [icon]="['fal', 'shop']" slot="start"></fa-icon>
									<ion-label>Shop</ion-label>
								</ion-item>
								<ion-item routerDirection="root" routerLink="app/tabs/club-special-orders" lines="none" detail="false" routerLinkActive="selected" *ngIf="sideBarMenu?.includes('special_orders') == false">
									<fa-icon [icon]="['fal', 'bags-shopping']" slot="start"></fa-icon>
									<ion-label>Special Orders</ion-label>
								</ion-item>
								<ion-item routerDirection="root" routerLink="app/tabs/club-subscriptions" lines="none" detail="false" routerLinkActive="selected" *ngIf="sideBarMenu?.includes('recurring_billing') == false">
									<fa-icon [icon]="['fal', 'repeat']" slot="start"></fa-icon>
									<ion-label>Subscriptions</ion-label>
								</ion-item>

								<ion-item routerDirection="root" routerLink="app/tabs/rentals" lines="none" detail="false" routerLinkActive="selected" *ngIf="sideBarMenu?.includes('rentals') == false">
									<fa-icon [icon]="['fal', 'truck-ramp-box']" slot="start"></fa-icon>
									<ion-label>Rentals</ion-label>
								</ion-item>
								<ion-item routerDirection="root" routerLink="app/tabs/club-shop-orders" lines="none" detail="false" routerLinkActive="selected">
									<fa-icon [icon]="['fal', 'diagram-predecessor']" slot="start"></fa-icon>
									<ion-label>Previous Orders</ion-label>
								</ion-item>
							</ion-menu-toggle>
						</div>

					</div>
					}


					<ion-accordion-group id="menu_about">
						<ion-accordion value="menu_about">
							<ion-item slot="header" auto-hide="true" (click)="scrollToTop('menu_about')">

								<ion-label>
									About &amp; Settings
								</ion-label>
							</ion-item>

							<ion-list slot="content">


								<ion-menu-toggle auto-hide="false">

									<ion-item routerDirection="root" routerLink="app/tabs/user-settings" lines="none" detail="false" routerLinkActive="selected">
										<fa-icon [icon]="['fal', 'gears']" slot="start"></fa-icon>
										<ion-label>Settings</ion-label>
									</ion-item>

									<ion-item routerDirection="root" routerLink="app/tabs/about" lines="none" detail="false" routerLinkActive="selected">
										<fa-icon [icon]="['fal', 'circle-question']" slot="start"></fa-icon>
										<ion-label>
											Help</ion-label>
									</ion-item>
									<ion-item routerDirection="root" routerLink="app/tabs/contact-dev/" lines="none" detail="false" routerLinkActive="selected">
										<fa-icon [icon]="['fal', 'message-pen']" slot="start"></fa-icon>
										<ion-label>Contact connectMyClub</ion-label>
									</ion-item>
									<ion-item routerDirection="root" routerLink="app/tabs/about-licences" lines="none" detail="false" routerLinkActive="selected">
										<fa-icon [icon]="['fab', 'github']" slot="start"></fa-icon>
										<ion-label>Licences</ion-label>
									</ion-item>
									<ion-item routerDirection="root" routerLink="app/tabs/about-privacy" lines="none" detail="false" routerLinkActive="selected">
										<fa-icon [icon]="['fal', 'file-shield']" slot="start"></fa-icon>
										<ion-label>
											Privacy Policy</ion-label>
									</ion-item>
									<ion-item routerDirection="root" routerLink="app/tabs/about-terms" lines="none" detail="false" routerLinkActive="selected">
										<fa-icon [icon]="['fal', 'list-ul']" slot="start"></fa-icon>
										<ion-label>Terms Of Use</ion-label>
									</ion-item>
									<ion-item routerDirection="root" routerLink="app/tabs/about-version" lines="none" detail="false" routerLinkActive="selected">
										<fa-icon [icon]="['fal', 'code-branch']" slot="start"></fa-icon>
										<ion-label>Version</ion-label>
									</ion-item>
								</ion-menu-toggle>
							</ion-list>
						</ion-accordion>
					</ion-accordion-group>


					<ion-menu-toggle auto-hide="false" class="logout-menu-item">
						<ion-item button (click)=" logout()" lines="none" detail="false">
							<fa-icon [icon]="['fal', 'right-from-bracket']" slot="start"></fa-icon>
							<ion-label>
								Logout
							</ion-label>
						</ion-item>
					</ion-menu-toggle>

				</ion-list>
			</ion-content>
		</ion-menu>

		@if(!isNative){
		<jeep-sqlite></jeep-sqlite>
		}

		<ion-router-outlet id="main"></ion-router-outlet>

	</ion-split-pane>
</ion-app>
